module.exports = __webpack_public_path__ + "images/13c39ae674f51582df04ae3d6229ab44-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = ./src/assets/images/logo.png
// module chunks = 0